const Label = ({children,  ...props}) => {
    return <span style={{overflowWrap: "break-word"}} {...props}>{children}</span>
}
export default Label